var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMembers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    rx: 20,
    fill: "#FFF0E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_12075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 16.0001C36.5697 15.9659 35.147 16.2181 33.8156 16.7418C32.4842 17.2655 31.2709 18.0502 30.2472 19.0497C29.2236 20.0492 28.4101 21.2434 27.8547 22.5619C27.2993 23.8804 27.0132 25.2966 27.0132 26.7273C27.0132 28.158 27.2993 29.5743 27.8547 30.8928C28.4101 32.2113 29.2236 33.4054 30.2472 34.4049C31.2709 35.4044 32.4842 36.1891 33.8156 36.7128C35.147 37.2366 36.5697 37.4887 38 37.4545C39.4303 37.4887 40.853 37.2366 42.1844 36.7128C43.5158 36.1891 44.729 35.4044 45.7527 34.4049C46.7764 33.4054 47.5898 32.2113 48.1452 30.8928C48.7006 29.5743 48.9868 28.158 48.9868 26.7273C48.9868 25.2966 48.7006 23.8804 48.1452 22.5619C47.5898 21.2434 46.7764 20.0492 45.7527 19.0497C44.729 18.0502 43.5158 17.2655 42.1844 16.7418C40.853 16.2181 39.4303 15.9659 38 16.0001ZM31.8666 43.5817C29.02 43.5817 26.2899 44.7126 24.277 46.7255C22.2641 48.7383 21.1333 51.4684 21.1333 54.3151V61.9725H54.8666V54.3151C54.8666 51.4684 53.7358 48.7383 51.7229 46.7255C49.71 44.7126 46.98 43.5817 44.1333 43.5817H31.8666Z",
    fill: "#FF832B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_12075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMembers);
export default __webpack_public_path__ + "static/media/dashboard-members.4aff7f8f997b8711b64cb6b02d65afef.svg";
export { ForwardRef as ReactComponent };